import LineEnvelopeIcon from 'LuxKit/Icons/line/LineEnvelopeIcon'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import { rem } from 'polished'
import { memo } from 'react'
import styled from 'styled-components'
import SupportNumberButton from '../../../../LuxKit/Button/SupportNumberButton'
import TextLink from '../../../../LuxKit/TextLink'
import BodyText from '../../../../LuxKit/Typography/BodyText'
import { useIntl } from 'react-intl'

const Container = styled(Sheet)`
  margin-top: ${rem(24)}; /* PLEASE DO NOT DO THIS! THIS IS JUST LEGACY. */
`

interface Props {
  heading?: string
  description?: string
  contactNumber?: App.GeoContact
  email?: string
  refCode?: string
  onSupportEmailClick?: () => void
  onSupportNumberClick?: () => void
  waiverMessage?: string
}

function HelpPane({ heading, description, contactNumber, email, refCode, onSupportEmailClick, onSupportNumberClick, waiverMessage }: Props) {
  const intl = useIntl()

  const defaultHeading = intl.formatMessage({
    id: 'AE3v4Zm78Um1yMF0w8oh',
    defaultMessage: 'Need help? Call our support team',
    description: 'Heading for help pane component in the customer support section',
  })

  const defaultDescription = intl.formatMessage({
    id: 'gwUHW46lBZzkqQc1Gho_',
    defaultMessage: 'Our customer service team are available anytime, 24 hours, 7 days a week',
    description: 'Default description text for help pane component in the help pane section',
  })

  const referenceCodeLabel = intl.formatMessage({
    id: '0FM7WJe7fPq4w8wIk6tJ',
    defaultMessage: 'Reference Code',
    description: 'Form field label for reference code in help pane component',
  })

  return <Container background="light-background" borderRadius="M" padding={16}>
    <Group direction="vertical" horizontalAlign="center" gap={12}>
      <BodyText variant="large" weight="bold">{heading ?? defaultHeading}</BodyText>
      <BodyText variant="medium">
        {description ?? defaultDescription}
      </BodyText>
      <SupportNumberButton onClick={onSupportNumberClick} currentContact={contactNumber} />
      {email && <div>
        <TextLink onClick={onSupportEmailClick} startIcon={<LineEnvelopeIcon />} href={`mailto:${email}`} rel="nofollow">{email}</TextLink>
      </div>}
      {refCode && <div>
        <BodyText variant="large" align="center" weight="bold">{referenceCodeLabel}</BodyText>
        <BodyText variant="large">{refCode}</BodyText>
      </div>}
      {waiverMessage && <BodyText variant="small" align="center">{waiverMessage}</BodyText>}
    </Group>
  </Container>
}

export default memo(HelpPane)
